<template>
  <div
    class="db-card"
    :class="{ 'db-has-illustration': $slots.illustration }"
  >
    <div
      v-if="$slots.illustration"
      class="db-card-illustration db-content-cover"
    >
      <slot name="illustration" />
    </div>
    <div
      v-if="$slots.logo"
      class="db-card-logo"
    >
      <slot name="logo" />
    </div>
    <slot name="content" />
  </div>
</template>

<style>
@import '@/assets/styles/commons/_cards.css';
</style>
